/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum KioskState {
    Unknown = 0,
    Active = 1,
    Unavailable = 2,
    Maintenance = 3,
    CashBoxAlarm = 4,
    OutOfService = 5,
}
